export interface ViralScoreInput {
  hook: string;
  retention: number;
  emotion: number;
}

export function calculateViralScore({ hook, retention, emotion }: ViralScoreInput): number {
  let score = 0;

  const hookLower = hook.toLowerCase();
  if (hookLower.includes("you won't believe")) score += 20;
  if (hookLower.includes("secret")) score += 15;
  if (hookLower.includes("nobody talks about")) score += 18;
  if (hookLower.includes("stop doing")) score += 12;
  if (hookLower.includes("mistake")) score += 10;
  if (hookLower.includes("truth about")) score += 14;
  if (hookLower.includes("how i")) score += 8;
  if (hookLower.includes("why you")) score += 10;

  score += retention * 0.5;
  score += emotion * 0.5;

  return Math.min(100, Math.round(score));
}

export function getScoreLabel(score: number): { label: string; color: string } {
  if (score >= 80) return { label: 'Viral', color: '#C2185B' };
  if (score >= 60) return { label: 'High', color: '#ff7043' };
  if (score >= 40) return { label: 'Medium', color: '#ffa726' };
  return { label: 'Low', color: '#8A8A96' };
}
